import { Group } from "@/interfaces/copilotTypes";
import React from "react";
import ThoughtStep from "./ThoughtStep";

function ThoughtGroup({ group }: { group: Group }) {
  return (
    <div>
      {group.steps.map((step) => (
        <ThoughtStep key={step._id} step={step} />
      ))}
    </div>
  );
}

export default ThoughtGroup;
